module.exports = __webpack_public_path__ + "static/media/contact-form-decoration-purple.1ed76363.png";